import React from 'react'
import styled from 'styled-components'
import { media } from '../utils/style-utils'
import bg from '../img/bg.jpg'
import logo from '../img/mini-logo.svg'

const FooterWrapper = styled.footer`
  background-image: url(${bg});
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  ${media.tablet`
    height: 200px;
  `};

  ${media.desktop`
    height: 300px;
  `};
`

const FooterImage = styled.img`
  width: 50px;
  display: block;
  ${media.desktop`
    width: auto;
  `};
`

const Footer = props => {
  const { sitename } = props
  return (
    <FooterWrapper>
      <FooterImage src={logo} alt={sitename} />
    </FooterWrapper>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js